<div class="row nova-font-style top-margin-15">
  <div class="col s12 m12 l12 xl12 remove-default-padding" id="help-content">
    <h2>Help</h2>
    <div class="top-margin-20" id="video-link">
      <span class="bold">How To Videos:</span>
      <div class="top-margin-10 right-padding-20 left-padding-20">
        <kendo-grid [data]="videoGridView" [pageable]="false" [sortable]="false" id="videos-link-grid">
          <kendo-grid-column media="(max-width: 900.98px)" title="Details" [width]="150">
            <ng-template kendoGridCellTemplate let-dataItem>
              <dl>
                <dd>
                  <div class="align-left">
                    <span class="bold">Name:</span>
                    {{ dataItem.Name }}
                  </div>
                </dd>
                <dd>
                  <div class="align-left">
                    <span class="bold">Description:</span>
                    {{ dataItem.Description }}
                  </div>
                </dd>
                <dd>
                  <div class="align-left">
                    <span class="bold">Link:</span>
                    <a rel="noopener noreferrer" href={{dataItem.Links}} target="_blank">
                      <span class="k-icon k-i-video-external k-required"></span>
                      <span class="clone-link">View</span>
                    </a>
                  </div>
                </dd>
              </dl>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="Name" title="Name" [width]="90" media="(min-width: 901px)">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div class="align-text">{{ dataItem.Name }}</div>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="Description" title="Description" [width]="130" media="(min-width: 901px)">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div class="align-text">{{ dataItem.Description }}</div>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="Links" title="Links" [width]="50" media="(min-width: 901px)"
            [headerStyle]="{'text-align': 'center'}">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div class="align-center">
                <a rel="noopener noreferrer" href={{dataItem.Links}} target="_blank">
                  <span class="k-icon k-i-video-external k-required"></span>
                  <span class="clone-link">View</span>
                </a>
              </div>
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
      </div>
    </div>

    <div class="top-margin-20" id="doc-link">
      <span class="bold">Other Resources:</span>
      <div class="top-margin-10 right-padding-20 left-padding-20">
        <kendo-grid [data]="docGridView" [pageable]="false" [sortable]="false" id="doc-link-grid">
          <!-- template for mobile -->
          <kendo-grid-column media="(max-width: 900.98px)" title="Details" [width]="150">
            <ng-template kendoGridCellTemplate let-dataItem>
              <dl>
                <dd>
                  <div class="align-left">
                    <span class="bold">Name:</span>
                    {{ dataItem.Name }}
                  </div>
                </dd>
                <dd>
                  <div class="align-left">
                    <span class="bold">Description:</span>
                    {{ dataItem.Description }}
                  </div>
                </dd>
                <dd>
                  <div class="align-left">
                    <span class="bold">Link:</span>
                    <a rel="noopener noreferrer" href={{dataItem.Doclinks}} target="_blank">
                      <span class="k-icon k-i-file-pdf k-i-pdf"></span>
                      <span class="clone-link">View</span>
                    </a>
                  </div>
                </dd>
              </dl>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="Name" title="Name" [width]="90" media="(min-width: 901px)">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div class="align-text">{{ dataItem.Name }}</div>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="Description" title="Description" [width]="130" media="(min-width: 901px)">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div class="align-text">{{ dataItem.Description }}</div>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="Links" title="Links" [width]="50" media="(min-width: 901px)"
            [headerStyle]="{'text-align': 'center'}">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div class="align-center">
                <a rel="noopener noreferrer" href={{dataItem.Doclinks}} target="_blank">
                  <span class="k-icon k-i-file-pdf k-i-pdf"></span>
                  <span class="clone-link">View</span>
                </a>
              </div>
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
      </div>
    </div>

    <div class="top-margin-20" id="ph-support">
      <span class="bold">Phone Support:</span>
      <div class="right-padding-20 left-padding-20">
        <p>{{businessHoursMsg}}<br />{{helpDeskPhone}}</p>
      </div>
    </div>
  </div>
</div>
